const RelativeRelationshipEnum = {
  GRANDPA: 1,
  GRANDMA: 2,
  FATHER: 3,
  MOTHER: 4,
  CHILD: 5,
  WIFE: 6,
  HUSBAND: 7,
  DAUGHTER: 8,
  SON: 9,
  GRANDCHILD: 10,
  OLDER_SISTER: 11,
  OLDER_BROTHER: 12,
  YOUNGER_SISTER: 13,
  YOUNGER_BROTHER: 14
}
export default RelativeRelationshipEnum


// WEBPACK FOOTER //
// ./src/enum/relativeRelationshipEnum.js